import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface SurViewReturnsDetailsModel {
    uri?: string;
    fromCompanyName?: string;
    fromAddress1?: string;
    fromAddress2?: string;
    fromCity?: string;
    fromPostalCode?: string;
    fromState?: string;
    fromCountry?: string;
    toCompanyName?: string;
    toAddress1?: string;
    toAddress2?: string;
    toCity?: string;
    toPostalCode?: string;
    toState?: string;
    toCountry?: string;
    rmaNumber?: string;
    webRMAId?: any;
    rmaDate?: string;
    expirationDate?: string;
    status?: string;
    total?: number;
    subTotal?:number;
    freightAmt?:number;
    totalDisplay:string;
    restockingFeeAmt?:number;
    taxAmt?:number;
    productList?: ProductList[]
    trackingList?: TrackingList[];
    viewdetailsdata?: any;
    // viewReturnsDetailsList?: ViewReturnsDetailsList[];
    properties?: Properties2;
}

export interface ProductList {
    creditMemoNumber: string;
    item: string;
    returnQuantity: number;
    receivedQuantity: number;
    remainingQuantity: number;
    returnReason: string;
    action: string;
    restockingFee: number;
    originalPrice: number;
    creditAmount: number;
    restockingFeeDisplay:string;
    originalPriceDisplay:string;
    creditAmountDisplay:string;
    sourceBrand?: string;
}

export interface TrackingList {
    invoiceNumber: string;
    trackingNumber: string;
    shippedDate: string;
}
export interface ViewReturnsDetailsParameter extends ApiParameter {
    rmaNumber?: string;
}
export interface Properties2 {}
export interface ViewReturnsDetailsModel {}

const ViewReturnsDetailsUrl = "/api/v2/returns/";

export async function getViewReturnsDetails(
    // parameter: ViewReturnsDetailsParameter,
    parameter: ViewReturnsDetailsParameter &
        HasOnSuccess<ViewReturnsDetailsModel> &
        HasOnComplete<ViewReturnsDetailsModel>,
) {
    const response = await get<SurViewReturnsDetailsModel>(`/api/v2/returns/${parameter.rmaNumber}`);
    return response;
}
